import * as React from "react";
const SvgChatDocumentationIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 20", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 6, cy: 7, r: 6, fill: "#ffd28d", style: {
  fill: "#ffd28d",
  fill: "color(display-p3 1 .8235 .5529)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#fff0d9", d: "M1.942 4.745a1.376 1.376 0 0 1 1.62-1.637l2.163.44q.275.057.55 0l2.163-.44a1.376 1.376 0 0 1 1.62 1.637l-.413 1.924c-.041.19-.041.388 0 .578l.413 1.925a1.376 1.376 0 0 1-1.62 1.637l-2.163-.441a1.4 1.4 0 0 0-.55 0l-2.163.44a1.376 1.376 0 0 1-1.62-1.636l.413-1.925c.041-.19.041-.387 0-.578z", style: {
  fill: "#fff0d9",
  fill: "color(display-p3 1 .9412 .851)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { width: 13, height: 13, x: 4.5, y: 6.5, fill: "#cbd5db", rx: 3.5, style: {
  fill: "#cbd5db",
  fill: "color(display-p3 .7961 .8351 .8577)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { width: 13, height: 13, x: 4.5, y: 6.5, stroke: "#fff", rx: 3.5, style: {
  stroke: "#fff",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { stroke: "#214b64", strokeLinecap: "round", strokeLinejoin: "round", d: "M11 16.6c.72 0 1.68-.48 1.68-.48l1.619.48a.297.297 0 0 0 .301-.301l-.48-1.139c.458-.782.48-2.16.48-2.16a3.6 3.6 0 1 0-4.978 3.326c.437.18.658.274 1.378.274", style: {
  stroke: "#214b64",
  stroke: "color(display-p3 .1299 .2942 .3928)",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { stroke: "#214b64", strokeLinejoin: "round", strokeWidth: 0.75, d: "M9.5 12H13m-3.5 2H12", style: {
  stroke: "#214b64",
  stroke: "color(display-p3 .1299 .2942 .3928)",
  strokeOpacity: 1
} }));
export default SvgChatDocumentationIcon;
